/* global $:false */

import 'jquery-ui/effect-highlight.js'
import htmx from 'htmx.org/dist/htmx.js'

export default class LiveBanner {
  static init () {
    htmx.on('htmx:historyRestore', (e) => {
      this._setupBindingsAndEventListeners()
    })
    this._setupBindingsAndEventListeners()
  }

  static bannerOrFullPage () {
    if (this._onLivePage()) { return this._showFullPage() }
    if (this._wasOnLivePage()) { return this._showMediumBanner() }

    switch (window.localStorage.getItem('live-banner-size')) {
      case 'small':
        this._showSmallBanner()
        break
      case 'medium':
        this._showMediumBanner()
        break
    }
  }

  static _setupBindingsAndEventListeners () {
    this._makeBannerClickable()
    this._bindBannerButtons()
    this._addEffectForNewBids()
    this._dontAddBannerToUnboostedPagesWhenAuctionStarts()
    this._reloadBidderPageForLoggedInCustomersWhenAuctionStarts()
  }

  static _dontAddBannerToUnboostedPagesWhenAuctionStarts () {
    $('.js-push-live-bidder-page').on('htmlPush:beforeReplace', e => {
      if ($(e.target).hasClass('js-push-live-bidder-page') && !window.gon.boost) { return false }

      return true
    })
  }

  static _loggedIn () {
    return (window.gon && window.gon.logged_in)
  }

  static _whenLivePageIsRerendered (fn) {
    $('.js-push-live-bidder-page').on('htmlPush:afterReplace', e => {
      if (e.target === e.currentTarget) { fn(e) }
    })
  }

  static _needToLoginMessageShown () {
    return $('.js-live-page-need-to-login-message').length > 0
  }

  static _reloadBidderPageForLoggedInCustomersWhenAuctionStarts () {
    this._whenLivePageIsRerendered (() => {
      if (this._onLivePage() && this._loggedIn() && this._needToLoginMessageShown()) {
        window.location.reload()
      }
    })
  }

  static _addEffectForNewBids () {
    this.currentLotId = -1

    $('.js-push-live-bidder-page').on('htmlPush:afterReplace', '.js-push-live-page-current-amount', e => {
      if (this.currentLotId === e.detail.metadata.lot_id || this.currentLotId === -1) {
        $('.js-live-page-current-amount').fadeTo(800, 0.5).fadeTo(800, 1)
      }
      this.currentLotId = e.detail.metadata.lot_id
    })
  }

  static _onLivePage () {
    return $('.c-live-page-active').length > 0
  }

  static _wasOnLivePage () {
    return $('.c-live-page-wrapper--full').length > 0
  }

  static _loadVideo () {
    if ($('.c-live-video').length === 0) {
      $.get('/live/video').done(response => { $('.c-live-page__video').html(response) })
    }
  }

  static _removeVideo () {
    $('.c-live-video').remove()
  }

  static _showFullPage () {
    $('.c-live-page-wrapper').toggleClass('c-live-page-wrapper--medium', false)
      .toggleClass('c-live-page-wrapper--small', false)
      .toggleClass('c-live-page-wrapper--full', true)
    this._loadVideo()
  }

  static _showMediumBanner () {
    $('.c-live-page-wrapper').toggleClass('c-live-page-wrapper--small', false)
      .toggleClass('c-live-page-wrapper--full', false)
      .toggleClass('c-live-page-wrapper--medium', true)
    window.localStorage.setItem('live-banner-size', 'medium')
    this._loadVideo()
  }

  static _showSmallBanner () {
    $('.c-live-page-wrapper').toggleClass('c-live-page-wrapper--medium', false)
      .toggleClass('c-live-page-wrapper--full', false)
      .toggleClass('c-live-page-wrapper--small', true)
    this._removeVideo()
    window.localStorage.setItem('live-banner-size', 'small')
  }

  static _makeBannerClickable () {
    $('.js-push-live-bidder-page').on('click', '.c-live-page', event => {
      if (this._onLivePage()) { return }
      // Don't change behaviour of existing a tags
      if (event.target.closest('a')) { return }

      this._hideFormForLoggedInUsersToNotShowStaleData()
      htmx.ajax('GET', '/live', '#js-boost-target').then(() => { window.scrollTo(0, 0) })
    })
  }

  static _hideFormForLoggedInUsersToNotShowStaleData () {
    if (window.gon && window.gon.logged_in) { $('[data-ajax-live-form]').css('opacity', 0) }
  }

  static _bindBannerButtons () {
    $('.c-live-page-wrapper').on('click', '.js-live-page-open-button', event => {
      event.preventDefault()
      event.stopPropagation()
      this._showMediumBanner()
    })

    $('.c-live-page-wrapper').on('click', '.js-live-page-close-button', event => {
      event.preventDefault()
      event.stopPropagation()
      this._showSmallBanner()
    })
  }
}
